import { useMutation } from "@apollo/client/react";
import {
  CreateStudentFeedback,
  CreateStudentFeedbackVariables,
} from "__generated__/types";
import { Button } from "common/buttons";
import { MarkdownField } from "common/components/forms/MarkdownField";
import { MutationLoadingOrError } from "common/components/forms/MutationLoadingOrError";
import { SubmitButton } from "common/components/forms/SubmitButton";
import gql from "graphql-tag";
import * as React from "react";
import { useState } from "react";
import { FormProvider, useForm } from "react-hook-form";

const MUTATION = gql`
  mutation AskQuestion($input: CreateStudentFeedbackInput!) {
    createStudentFeedback(input: $input) {
      feedback {
        id
      }
    }
  }
`;

interface FormValues {
  question: string;
}

export const AskQuestion: React.FC = () => {
  const methods = useForm<FormValues>();
  const [sent, setSent] = useState<boolean>(false);
  const [mutate, { loading, error }] = useMutation<
    CreateStudentFeedback,
    CreateStudentFeedbackVariables
  >(MUTATION);

  const onSubmit = async (data: FormValues) => {
    const result = await mutate({
      variables: {
        input: {
          body: {
            content: data.question,
            isMarkdown: true,
          },
        },
      },
    });

    if (result.data) {
      setSent(true);
    }
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        {!sent ? (
          <MarkdownField<FormValues>
            name="question"
            title="Hva lurer du på?"
            required={true}
            defaultValue=""
          />
        ) : (
          <div>
            Spørsmålet ditt har blitt sendt inn og vil besvares så raskt som
            mulig.
          </div>
        )}

        <MutationLoadingOrError loading={loading} error={error} />

        <p>
          {!sent ? (
            <SubmitButton>Send inn</SubmitButton>
          ) : (
            <Button
              onClick={() => {
                setSent(false);
              }}
            >
              Send nytt spørsmål
            </Button>
          )}
        </p>
      </form>
    </FormProvider>
  );
};
